const TRIGGER_SELECTOR = '.topic-list__teaser-title'
const CONTENT_SELECTOR = '.topic-list__teaser-content'
const ACTIVE_CLASS = 'topic-list__teaser--open'

const LETTER_BUTTON_CLASS = 'topic-list__letters-letter'
const TEASER_CLASS = 'topic-list__teaser'
const ALL_LETTERS_BUTTON_CLASS = 'topic-list__letters-all'
const TEASERS_NO_RESULT_ELEMENT_CLASS = 'topic-list__teasers--no-result'
const TEASER_NO_RESULT_ACTIVE_CLASS = 'topic-list__teasers--no-result-active'

const HIDDEN_TEASER_STATE_CLASS = 'topic-list__teaser--hidden'

export {
  TRIGGER_SELECTOR,
  CONTENT_SELECTOR,
  ACTIVE_CLASS,
  LETTER_BUTTON_CLASS,
  TEASER_CLASS,
  ALL_LETTERS_BUTTON_CLASS,
  TEASERS_NO_RESULT_ELEMENT_CLASS,
  TEASER_NO_RESULT_ACTIVE_CLASS,
  HIDDEN_TEASER_STATE_CLASS,
}
